<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <Background v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/sanitasi.png"
        alt="HAIWAN TERBIAR"
        class="pbt-image"
      >
      <!-- Center the line under the image -->
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
->

      <h2> AKTIVITI SANITASI DAN DISINFEKSI DIJALANKAN OLEH PBT</h2>
      
      <div>
        <!-- sanitasi  Section -->
        <div class="sanitasi">
          <div class="activity-grid">
            <div
              v-for="item in sanitasiActivities.sanitasi"
              :key="item.title"
              class="activity-box"
            >
              <div class="box-overlay">
                <h3 class="box-title">
                  {{ item.title }}
                </h3>
                <p class="box-value">
                  {{ item.value }}
                </p>
              </div>
              <img
                :src="item.image"
                class="responsive-image"
                alt="activity-image"
              >
            </div>
          </div>
          <Update />
        </div>
      </div>

      <div class="pemantauan ">
        <h2>PEMANTAUAN AKTIVITI SANITASI DAN DISINFEKSI DI PREMIS BUKAN MILIK PBT</h2>
        <div class="first-row">
          <div
            v-for="(item, index) in premis.slice(0, 2)"
            :key="index"
            :style="{ background: item.color }"
            class="box"
          >
            <p>{{ item.title }}</p>
            <span class="count">{{ item.location }}</span>
          </div>
        </div>

        <div class="second-row">
          <div
            v-for="(item, index) in premis.slice(2)"
            :key="index"
            class="box small"
            :style="{ background: item.color }"
          >
            <p>{{ item.title }}</p>
            <span class="count">{{ item.location }}</span>
          </div>
        </div>
      </div>  
        <Menu />
    </div>
  </Background>
</template>

<script setup>
import boxImage from '@/assets/spah/box.png'
import Menu from '@/components/menu-items/utama-menu.vue'
import { useHttpService } from "@/httpService"
import { onMounted, ref } from 'vue'

//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/i-tegur',
  meta: {
    layout: 'blank',
    public: true,
  },
})


const sanitasiPremisBukanPbt = ref({ 
  // eslint-disable-next-line camelcase
  bilangan_pemantauan: 0,
  // eslint-disable-next-line camelcase
  bilangan_premis_dipantau: 0,
  // eslint-disable-next-line camelcase
  bilangan_penguatkuasaan: 0,
  // eslint-disable-next-line camelcase
  bilangan_amaran: 0,
  // eslint-disable-next-line camelcase
  bilangan_kompaun: 0,
  // eslint-disable-next-line camelcase
  bilangan_lain_lain_tindakan: 0,
})

const sanitasiPbt = ref({ 
  // eslint-disable-next-line camelcase
  jumlah_keseluruhan_aktiviti: 0,
  // eslint-disable-next-line camelcase
  jumlah_premis_terlibat: 0,
  // eslint-disable-next-line camelcase
  jumlah_aktiviti_sanitasi: 0,
  // eslint-disable-next-line camelcase
  jumlah_aktiviti_disinfeksi: 0,
  // eslint-disable-next-line camelcase
  bilangan_premis_pbt: 0,
  // eslint-disable-next-line camelcase
  bilangan_pasar_awam: 0,
  // eslint-disable-next-line camelcase
  bilangan_pasar_malam: 0,
  // eslint-disable-next-line camelcase
  bilangan_pasar_tani: 0,
  // eslint-disable-next-line camelcase
  bilangan_hentian_awam: 0,
  // eslint-disable-next-line camelcase
  bilangan_taman_rekreasi_awam: 0,
  // eslint-disable-next-line camelcase
  bilangan_medan_selera: 0,
  // eslint-disable-next-line camelcase
  bilangan_tandas_awam: 0,
  // eslint-disable-next-line camelcase
  bilangan_fasiliti_sukan_rekreasi: 0,
  // eslint-disable-next-line camelcase
  bilangan_lain_lain_kemudahan: 0,
})

const sanitasiActivities = computed(() => ({
  sanitasi: [
    { title: "Jumlah Keseluruhan Aktiviti", value: numberWithCommas(sanitasiPbt.value.jumlah_keseluruhan_aktiviti), image: boxImage },
    { title: "Jumlah Premis Terlibat", value: numberWithCommas(sanitasiPbt.value.jumlah_premis_terlibat), image: boxImage },
    { title: "Jumlah Aktiviti Sanitasi", value: numberWithCommas(sanitasiPbt.value.jumlah_aktiviti_sanitasi), image: boxImage },
    { title: "Jumlah Aktiviti Disinfeksi", value: numberWithCommas(sanitasiPbt.value.jumlah_aktiviti_disinfeksi), image: boxImage },
    { title: "Bil. Premis PBT", value: numberWithCommas(sanitasiPbt.value.bilangan_premis_pbt), image: boxImage },
    { title: "Bil. Pasar Awam", value: numberWithCommas(sanitasiPbt.value.bilangan_pasar_awam), image: boxImage },
    { title: "Bil. Pasar Malam", value: numberWithCommas(sanitasiPbt.value.bilangan_pasar_malam), image: boxImage },
    { title: "Bil. Pasar Harian / Tani", value: numberWithCommas(sanitasiPbt.value.bilangan_pasar_tani), image: boxImage },
    { title: "Bil. Hentian Awam", value: numberWithCommas(sanitasiPbt.value.bilangan_hentian_awam), image: boxImage },
    { title: "Bil. Taman Rekreasi Awam", value: numberWithCommas(sanitasiPbt.value.bilangan_taman_rekreasi_awam), image: boxImage },
    { title: "Bil. Medan Selera", value: numberWithCommas(sanitasiPbt.value.bilangan_medan_selera), image: boxImage },
    { title: "Bil. Tandas Awam", value: numberWithCommas(sanitasiPbt.value.bilangan_tandas_awam), image: boxImage },
    { title: "Bil. Fasiliti Sukan & Rekreasi", value: numberWithCommas(sanitasiPbt.value.bilangan_fasiliti_sukan_rekreasi), image: boxImage },
    { title: "Bil. Lain-lain Kemudahan", value: numberWithCommas(sanitasiPbt.value.bilangan_lain_lain_kemudahan), image: boxImage },
  ],
}))


const premis = computed(() => [
  { title: 'Bil. Pemantauan Dijalankan', location: numberWithCommas(sanitasiPremisBukanPbt.value.bilangan_pemantauan),  color: 'linear-gradient(0deg, #808080 0%, #404040 100%)'   },
  { title: 'Bilangan Premis Dipantau', location: numberWithCommas(sanitasiPremisBukanPbt.value.bilangan_premis_dipantau), color: 'linear-gradient(0deg, #808080 0%, #404040 100%)'  },
  { title: 'Bil. Penguatkuasaan', location: numberWithCommas(sanitasiPremisBukanPbt.value.bilangan_penguatkuasaan), color: 'linear-gradient(0deg, #029708 0%, #013103 100%)' }, 
  { title: 'Bil. Amaran', location: numberWithCommas(sanitasiPremisBukanPbt.value.bilangan_amaran), color: 'linear-gradient(0deg, #FF0000 0%, #8B0000 100%)'  },
  { title: 'Bil. Kompaun', location: numberWithCommas(sanitasiPremisBukanPbt.value.bilangan_kompaun), color: 'linear-gradient(0deg, #FFD700 0%, #FFEC8B 100%)'  }, 
  { title: 'Bil. Lain-lain Tindakan', location: numberWithCommas(sanitasiPremisBukanPbt.value.bilangan_lain_lain_tindakan), color: 'linear-gradient(0deg, #0000FF 0%, #5F9EA0 100%)' }, 
])


const { httpGet, numberWithCommas } = useHttpService()

const responseData = ref(null)

const sanitasi = ref(null)


async function loadDataFromApi() {
  try {


    const currentYear = new Date().getFullYear()
    // Construct the URL with the query parameters
    // const response = `kesihatan-persekitaran/cegah-jangkit/program-sanitasi-disinfeksi`
    const response = await httpGet(
      `kesihatan-persekitaran/cegah-jangkit/program-sanitasi-disinfeksi?year=${currentYear}`
    )
 
    responseData.value = response
    sanitasi.value = response.data.sanitasi
  
  
    sanitasiPremisBukanPbt.value = {
      // eslint-disable-next-line camelcase
      bilangan_pemantauan: sanitasi.value.bilangan_pemantauan,
      // eslint-disable-next-line camelcase
      bilangan_premis_dipantau: sanitasi.value.bilangan_premis_dipantau,
      // eslint-disable-next-line camelcase
      bilangan_penguatkuasaan: parseInt(sanitasi.value.bilangan_amaran) + parseInt(sanitasi.value.bilangan_kompaun) + parseInt(sanitasi.value.bilangan_lain_lain_tindakan),
      // eslint-disable-next-line camelcase
      bilangan_amaran: sanitasi.value.bilangan_amaran,
      // eslint-disable-next-line camelcase
      bilangan_kompaun: sanitasi.value.bilangan_kompaun,
      // eslint-disable-next-line camelcase
      bilangan_lain_lain_tindakan: sanitasi.value.bilangan_lain_lain_tindakan,
    }


    sanitasiPbt.value = {
      // eslint-disable-next-line camelcase
      jumlah_keseluruhan_aktiviti: sanitasi.value.jumlah_keseluruhan_aktiviti,
      // eslint-disable-next-line camelcase
      jumlah_premis_terlibat: sanitasi.value.jumlah_premis_terlibat,
      // eslint-disable-next-line camelcase
      jumlah_aktiviti_sanitasi: sanitasi.value.jumlah_aktiviti_sanitasi,
      // eslint-disable-next-line camelcase
      jumlah_aktiviti_disinfeksi: sanitasi.value.jumlah_aktiviti_disinfeksi,
      // eslint-disable-next-line camelcase
      bilangan_premis_pbt: sanitasi.value.bilangan_premis_pbt,
      // eslint-disable-next-line camelcase
      bilangan_pasar_awam: sanitasi.value.bilangan_pasar_awam,
      // eslint-disable-next-line camelcase
      bilangan_pasar_malam: sanitasi.value.bilangan_pasar_malam,
      // eslint-disable-next-line camelcase
      bilangan_pasar_tani: sanitasi.value.bilangan_pasar_harian,
      // eslint-disable-next-line camelcase
      bilangan_hentian_awam: sanitasi.value.bilangan_hentian_awam,
      // eslint-disable-next-line camelcase
      bilangan_taman_rekreasi_awam: sanitasi.value.bilangan_taman_rekreasi_awam,
      // eslint-disable-next-line camelcase
      bilangan_medan_selera: sanitasi.value.bilangan_medan_selera,
      // eslint-disable-next-line camelcase
      bilangan_tandas_awam: sanitasi.value.bilangan_tandas_awam,
      // eslint-disable-next-line camelcase
      bilangan_dewan_orang_ramai: sanitasi.value.bilangan_dewan_orang_ramai,
      // eslint-disable-next-line camelcase
      bilangan_fasiliti_sukan_rekreasi: sanitasi.value.bilangan_fasiliti_sukan,
      // eslint-disable-next-line camelcase
      bilangan_lain_lain_kemudahan: sanitasi.value.bilangan_lain_lain_kemudahan,
    }

  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}


onMounted(() => {
  loadDataFromApi()
  
})
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; /* Rounded corners */
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%); /* Shadow for depth */
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}


.sanitasi {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  border-radius: 15px;
  margin-bottom: 20px;
  background-color: rgba(255, 255, 255, 0.85);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-top: 0; /* Set top margin to 0 to eliminate the gap */
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* This ensures 4 equal-width boxes */
  gap: 30px; /* Adjust the spacing between the boxes */
}



.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.pemantauan {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
}

/* First row with two items */
.first-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Two equal columns */
  gap: 20px;
  margin-bottom: 20px;
}

/* Second row with Gred A, B, and C */
.second-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* Three equal columns */
  gap: 20px;
}

.box {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  height: 100px;
  transition: transform 0.3s;
}

.box:hover {
  transform: translateY(-5px);
}

.box p,
.box .count {
  color: white;
  font-weight: bold;
  text-align: center;
}

.box p {
  font-size: 1rem;
}

.box .count {
  font-size: 2rem;
}



.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 80%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}



h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: left;
}



.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}


.input-item {
  flex: 1;
  margin-right: 15px;
}


.input-item:last-child {
  margin-right: 0;
}



.main-image-container {
  position: relative;
  display: inline-block;
}


.center-content {
  text-align: center;
}

.fit-box {
  padding: 20px;
  margin: 0 auto;
}

.white-card {
  background-color: rgb(202, 229, 247) !important;
}

.black-text {
  color: black !important;
}



.main-number-overlay {
  position: absolute;
  top: 85%; /* Adjusted to position number closer to the bottom */
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px 20px;
  border-radius: 5px;
}

.tandas {
  display: grid;
  grid-template-columns: 1fr 1fr; 
  grid-gap: 10px; /* Reduced gap between the main and star rating images */
  margin-top: 10px; /* Adjusted margin for smaller space between main and tandas sections */
}

.tandas-container {
  position: relative;
  width: 100%;
  max-width: 450px; /* Adjust the size to fit 2 columns */
  margin: 0 auto;
  border-radius: 10px;
  overflow: hidden;
}

.tandas-container img {
  border-radius: 10px; /* Optional: Add rounded corners */
}

.number-overlay {
  position: absolute;
  top: 50%;
  left: 90%;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  font-weight: bold;
  color: #a80000;
  padding: 10px;
  border-radius: 5px;
}



.v-tab {
  color: black !important; /* Change the color of tab text to black */
}

.tab-content {
  padding: 20px;
}

.sanitasi-stats {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.navigation-card {
  width: 100%;
  background-color: rgba(255, 255, 255, 65%); 
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);

}




.activity-box {
  position: relative;
  display: inline-block;
  width: 100%;
  height: auto;
  border-radius: 10px;
  overflow: hidden;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.box-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
}


.box-value {
  font-size: 1.5rem;
  font-weight: bold;
  color: #a80000;
}

.activity-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* This ensures 4 equal-width boxes */
  gap: 30px; /* Adjust the spacing between the boxes */
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}


.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  max-inline-size: 1400px;
  margin-top: 40px;
}

@media (max-width: 1024px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }

  .activity-grid {
    grid-template-columns: repeat(3, 1fr); /* 3 columns */
  }

  .main-number-overlay {
    font-size: 2.5rem;
  }

  .number-overlay {
    font-size: 1.8rem;
  }
}

/* For screens up to 768px */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .activity-grid {
    grid-template-columns: repeat(2, 1fr); /* 2 columns */
  }

  .main-number-overlay {
    font-size: 2rem;
  }

  .number-overlay {
    font-size: 1.5rem;
  }
}

/* For screens up to 480px */
@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .pbt-image {
    max-width: 100%; /* Adjusted size for smaller screens */
  }

  h2 {
    font-size: 1.2rem;
  }

  .activity-grid,
  .tandas {
    grid-template-columns: 1fr; /* Single column */
  }

  .main-number-overlay {
    font-size: 1.8rem;
  }

  .number-overlay {
    font-size: 1.2rem;
  }

  .activity-box,
  .tandas-container {
    padding: 10px;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .values-layered h3 {
    font-size: 1rem;
  }

  .number {
    font-size: 1.5rem;
  }

  .first-row,
  .second-row {
    grid-template-columns: 1fr; /* Single column layout */
    gap: 10px; /* Reduced gap between boxes */
  }
  
  .box {
    width: 100%; /* Ensures full width */
    margin: 0 auto;
  }
}
</style>
